import userflow from "userflow.js";

import { isUserflowActive } from "./config";

export const identifyUserToUserflow = (currentUser: User): void => {
  if (!isUserflowActive) {
    return;
  }

  const {
    user_id: userId,
    email,
    first_name: firstName,
    last_name: lastName,
    date_joined: dateJoined,
  } = currentUser;

  // Get name from firstName and lastName if available
  const name =
    firstName && lastName
      ? `${firstName} ${lastName}`
      : firstName || lastName || undefined;

  // Format dateJoined to ISO if available
  const signedUpAt = dateJoined
    ? new Date(dateJoined).toISOString()
    : undefined;

  userflow.identify(String(userId), {
    name,
    email,
    signed_up_at: signedUpAt,
  });
};
